module.exports = __webpack_public_path__ + "static/media/home-hero.ded134f7.webp";